var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.790811 6.28919C0.227027 6.57297 0 7.02892 0 7.65135V20.3497C0 20.9722 0.227027 21.3714 0.790811 21.7119L11.5065 27.8151C11.7522 27.9374 12.0229 28.0011 12.2973 28.0011C12.5717 28.0011 12.8424 27.9374 13.0881 27.8151L23.8038 21.7119C24.3714 21.3714 24.5946 20.9722 24.5946 20.3497V7.65135C24.5946 6.9154 24.2522 6.51622 23.8038 6.28919L13.0881 0.185946C12.8424 0.0636496 12.5717 0 12.2973 0C12.0229 0 11.7522 0.0636496 11.5065 0.185946L0.790811 6.28919Z",
    fill: "#612EF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.707 11.3428C16.6216 11.3693 12.5048 15.6393 12.5048 20.9063V21.1295H12.1094V20.9063C12.1094 15.6393 7.98512 11.3693 2.89025 11.3428C2.85606 11.6772 2.83901 12.0131 2.83917 12.3493C2.83917 16.4679 5.36107 19.9793 8.89323 21.3263C9.98253 21.7325 11.136 21.9395 12.2986 21.9374C13.461 21.9364 14.6139 21.7296 15.704 21.3263C19.2343 19.9793 21.7581 16.4679 21.7581 12.3493C21.7582 12.0131 21.7412 11.6772 21.707 11.3428Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4376 11.0672C15.6197 9.88506 15.6197 7.96845 14.4376 6.78633C13.2554 5.6042 11.3388 5.6042 10.1567 6.78633C8.97458 7.96845 8.97458 9.88506 10.1567 11.0672C11.3388 12.2493 13.2554 12.2493 14.4376 11.0672Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogo);
export default __webpack_public_path__ + "static/media/ic_logo.d85c0f84171b612fc4de509c439358f7.svg";
export { ForwardRef as ReactComponent };